import type { FormType } from '@pbk-web/types';

import type { ApiResponse } from '../models/ApiResponse';
import type { ClientModule, ClientModuleSummary } from '../models/ClientModule';
import type { DataExportJobDetailsResponse } from '../models/DataExport';
import type { Descriptor } from '../models/Descriptor';
import type { IndexListItem } from '../models/Document';
import type { ClientModuleTemplateFormInfoResponse } from '../models/Module';
import BaseService from './BaseService';

type ClientModuleTemplateFormFilter = {
  clientModuleId?: string;
  latestOnly?: boolean;
  includeArchived?: boolean;
  types?: (typeof FormType)[keyof typeof FormType][];
  searchTerm?: string;
  pageSize?: number;
  pageNumber?: number;
};

export default class ModuleService extends BaseService {
  public static createModule(clientId: string, templateModuleId: string): Promise<ApiResponse<ClientModule>> {
    return this.post('/v1/modules', {
      templateModuleId,
      clientId,
    });
  }

  public static getModule(id: string): Promise<ApiResponse<ClientModule>> {
    return this.get(`/v1/modules/${id}`);
  }

  public static getModuleInfo(id: string): Promise<ApiResponse<Descriptor>> {
    return this.get(`/v1/modules/${id}/info`);
  }

  public static getModules(): Promise<ApiResponse<ClientModuleSummary[]>> {
    return this.get(`/v1/modules`);
  }

  public static getFormTemplates(
    clientId: string,
    filter?: ClientModuleTemplateFormFilter,
  ): Promise<ApiResponse<ClientModuleTemplateFormInfoResponse[]>> {
    return this.get(`/v1/modules/form-templates`, { params: { clientId: clientId, ...filter } });
  }

  public static deleteModule(moduleId: string): Promise<ApiResponse<boolean>> {
    return this.delete(`/v1/modules/${moduleId}`);
  }

  public static getIndexes(clientModuleId: string, pageNumber: number, pageSize: number): Promise<ApiResponse<IndexListItem[]>> {
    return this.get(`/v1/modules/${clientModuleId}/indexes`, { params: { pageNumber: pageNumber, pageSize: pageSize } });
  }

  public static async downloadIndexes(clientModuleId: string, indexId?: string): Promise<ApiResponse<DataExportJobDetailsResponse>> {
    return this.get(`/v1/modules/${clientModuleId}/indexes/pdf`, {
      params: { indexId: indexId },
    });
  }
}
